import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

type EditorMode = 'builder' | 'json' | 'preview';

interface EditorModeToggleProps {
  mode: EditorMode;
  onChange: (mode: EditorMode) => void;
  disabled?: boolean;
}

export const EditorModeToggle: React.FC<EditorModeToggleProps> = ({
  mode,
  onChange,
  disabled = false,
}) => {
  return (
    <div
      className={styles.addConditionRow}
      style={{ border: 'none', padding: '0 0 0.75rem' }}
      role="tablist"
      aria-label="Editor mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'builder'}
        aria-controls="segment-editor-panel"
        onClick={() => onChange('builder')}
        disabled={disabled}
        className={mode === 'builder' ? styles.addConditionBtn : undefined}
        style={mode === 'builder' ? { borderStyle: 'solid', borderColor: '#d1d5db' } : undefined}>
        Builder
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'json'}
        aria-controls="segment-editor-panel"
        onClick={() => onChange('json')}
        disabled={disabled}
        className={mode === 'json' ? styles.addConditionBtn : undefined}
        style={mode === 'json' ? { borderStyle: 'solid', borderColor: '#d1d5db' } : undefined}>
        JSON Editor
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'preview'}
        aria-controls="segment-editor-panel"
        onClick={() => onChange('preview')}
        disabled={disabled}
        className={mode === 'preview' ? styles.addConditionBtn : undefined}
        style={mode === 'preview' ? { borderStyle: 'solid', borderColor: '#d1d5db' } : undefined}>
        Preview
      </button>
    </div>
  );
};
